import type { ModelDefinition } from "@/models.js";

export const metaModels = [
	{
		id: "llama-3.1-8b-instruct",
		name: "Llama 3.1 8B Instruct",
		description: "Compact Llama 3.1 for efficient text generation.",
		family: "meta",
		releasedAt: new Date("2024-07-23"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "meta.llama3-1-8b-instruct-v1:0",
				stability: "unstable",
				inputPrice: "0.22e-6",
				outputPrice: "0.22e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: 2048,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: false,
				deactivatedAt: new Date("2026-04-25"),
			},
			{
				providerId: "nebius",
				externalId: "meta-llama/Meta-Llama-3.1-8B-Instruct",
				inputPrice: "0.02e-6",
				outputPrice: "0.06e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: false,
				deactivatedAt: new Date("2026-04-25"),
			},
			{
				providerId: "inference.net",
				stability: "unstable",
				externalId: "meta-llama/llama-3.1-8b-instruct/fp-8",
				inputPrice: "0.07e-6",
				outputPrice: "0.33e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: false,
				deactivatedAt: new Date("2026-04-25"),
			},
			{
				providerId: "together-ai",
				externalId: "meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo",
				// Retired from Together.ai serverless API
				deactivatedAt: new Date("2026-03-27"),
				inputPrice: "0.06e-6",
				outputPrice: "0.06e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: false,
			},
			{
				// Cerebras: FP16
				providerId: "cerebras",
				externalId: "llama3.1-8b",
				inputPrice: "0.1e-6",
				outputPrice: "0.1e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				// Note: Tool calling is unreliable for llama3.1-8b on Cerebras
				tools: false,
				jsonOutput: true,
				supportedParameters: [
					"temperature",
					"max_tokens",
					"top_p",
					"response_format",
				],
				deactivatedAt: new Date("2026-04-25"),
			},
			{
				providerId: "novita",
				externalId: "meta-llama/llama-3.1-8b-instruct",
				inputPrice: "0.02e-6",
				outputPrice: "0.05e-6",
				requestPrice: "0",
				contextSize: 16384,
				maxOutput: 16384,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
				deactivatedAt: new Date("2026-04-25"),
			},
		],
	},
	{
		id: "llama-3.1-70b-instruct",
		name: "Llama 3.1 70B Instruct",
		description: "Mid-size Llama 3.1 with balanced performance.",
		family: "meta",
		releasedAt: new Date("2024-07-23"),
		providers: [
			{
				providerId: "aws-bedrock",
				externalId: "meta.llama3-1-70b-instruct-v1:0",
				stability: "unstable",
				inputPrice: "0.72e-6",
				outputPrice: "0.72e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: 2048,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: false,
			},
		],
	},
	{
		id: "llama-3.2-11b-instruct",
		name: "Llama 3.2 11B Instruct",
		description: "Llama 3.2 with improved instruction following.",
		family: "meta",
		releasedAt: new Date("2024-09-25"),
		providers: [
			{
				providerId: "inference.net",
				stability: "unstable",
				externalId: "meta-llama/llama-3.2-11b-instruct/fp-16",
				inputPrice: "0.07e-6",
				outputPrice: "0.33e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "llama-3.1-nemotron-ultra-253b",
		name: "Llama 3.1 Nemotron Ultra 253B",
		description: "NVIDIA-tuned Llama 3.1 253B for maximum capability.",
		family: "meta",
		releasedAt: new Date("2025-04-07"),
		providers: [
			{
				providerId: "nebius",
				externalId: "nvidia/Llama-3_1-Nemotron-Ultra-253B-v1",
				inputPrice: "0.6e-6",
				outputPrice: "1.8e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "llama-guard-4-12b",
		name: "Llama Guard 4 12B",
		description: "Safety-focused model for content moderation.",
		family: "meta",
		releasedAt: new Date("2025-04-30"),
		providers: [
			{
				providerId: "groq",
				externalId: "meta-llama/llama-guard-4-12b",
				// Decommissioned by Groq
				deactivatedAt: new Date("2026-03-29"),
				inputPrice: "0.2e-6",
				outputPrice: "0.2e-6",
				requestPrice: "0",
				contextSize: 131072,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: false,
			},
		],
	},
	{
		id: "llama-3.3-70b-instruct",
		name: "Llama 3.3 70B Instruct",
		description: "Latest Llama 3.3 70B with enhanced capabilities.",
		family: "meta",
		releasedAt: new Date("2024-12-06"),
		providers: [
			{
				providerId: "nebius",
				externalId: "meta-llama/Llama-3.3-70B-Instruct",
				inputPrice: "0.13e-6",
				outputPrice: "0.4e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				// Nebius does not reliably support tool_choice
				supportedParameters: [
					"temperature",
					"max_tokens",
					"top_p",
					"frequency_penalty",
					"presence_penalty",
					"stop",
					"stream",
					"response_format",
					"tools",
				],
			},
			{
				// Cerebras: FP16
				providerId: "cerebras",
				test: "skip",
				externalId: "llama-3.3-70b",
				inputPrice: "0.85e-6",
				outputPrice: "1.2e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				supportedParameters: [
					"temperature",
					"max_tokens",
					"top_p",
					"response_format",
				],
			},
			{
				providerId: "novita",
				test: "skip",
				externalId: "meta-llama/llama-3.3-70b-instruct",
				inputPrice: "0.135e-6",
				outputPrice: "0.4e-6",
				requestPrice: "0",
				contextSize: 131072,
				maxOutput: 120000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: false,
			},
		],
	},
	{
		id: "llama-3.1-405b-instruct",
		name: "Llama 3.1 405B Instruct",
		description: "Largest Llama 3.1 model with 405B parameters.",
		family: "meta",
		releasedAt: new Date("2024-07-23"),
		providers: [
			{
				providerId: "nebius",
				externalId: "meta-llama/Meta-Llama-3.1-405B-Instruct",
				inputPrice: "1.0e-6",
				outputPrice: "3.0e-6",
				requestPrice: "0",
				contextSize: 128000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				deactivatedAt: new Date("2025-11-03"),
			},
		],
	},
	// {
	// 	id: "llama-guard-3-8b",
	// 	name: "Llama Guard 3 8B",
	// 	family: "meta",
	// 	deprecatedAt: undefined,
	// 	deactivatedAt: undefined,
	// 	providers: [
	// 		{
	// 			providerId: "nebius",
	// 			test: "only",
	// 			externalId: "meta-llama/Llama-Guard-3-8B",
	// 			inputPrice: "0.02e-6",
	// 			outputPrice: "0.06e-6",
	// 			requestPrice: "0",
	// 			contextSize: 8192,
	// 			maxOutput: undefined,
	// 			streaming: true,
	// 			vision: false,
	// 			tools: false,
	// 		},
	// 	],
	// 	jsonOutput: false,
	// },
	{
		id: "llama-4-scout",
		name: "Llama 4 Scout",
		description: "Llama 4 Scout for efficient multi-turn conversations.",
		family: "meta",
		releasedAt: new Date("2025-04-05"),
		providers: [
			{
				providerId: "together-ai",
				stability: "unstable" as const,
				externalId: "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
				inputPrice: "0.18e-6",
				outputPrice: "0.59e-6",
				requestPrice: "0",
				contextSize: 32768,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: false,
				deactivatedAt: new Date("2026-04-25"),
			},
		],
	},
	{
		id: "llama-4-scout-17b-instruct",
		name: "Llama 4 Scout 17B Instruct",
		description: "Compact Llama 4 Scout with vision support.",
		family: "meta",
		releasedAt: new Date("2025-04-05"),
		providers: [
			{
				stability: "unstable",
				providerId: "aws-bedrock",
				externalId: "meta.llama4-scout-17b-instruct-v1:0",
				inputPrice: "0.17e-6",
				outputPrice: "0.66e-6",
				requestPrice: "0",
				contextSize: 8192,
				maxOutput: 2048,
				streaming: true,
				reasoningOutput: "omit",
				vision: true,
				tools: false,
				jsonOutput: false,
			},
			{
				stability: "unstable",
				providerId: "novita",
				externalId: "meta-llama/llama-4-scout-17b-16e-instruct",
				inputPrice: "0.18e-6",
				outputPrice: "0.59e-6",
				requestPrice: "0",
				contextSize: 131072,
				maxOutput: 131072,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "llama-4-maverick-17b-instruct",
		name: "Llama 4 Maverick 17B Instruct",
		description: "Llama 4 Maverick variant with vision capabilities.",
		family: "meta",
		releasedAt: new Date("2025-04-05"),
		providers: [
			{
				stability: "unstable",
				providerId: "aws-bedrock",
				externalId: "meta.llama4-maverick-17b-instruct-v1:0",
				inputPrice: "0.24e-6",
				outputPrice: "0.97e-6",
				requestPrice: "0",
				contextSize: 8192,
				maxOutput: 2048,
				streaming: true,
				reasoningOutput: "omit",
				vision: true,
				tools: false,
				jsonOutput: false,
			},
			{
				providerId: "novita",
				externalId: "meta-llama/llama-4-maverick-17b-128e-instruct-fp8",
				inputPrice: "0.27e-6",
				outputPrice: "0.85e-6",
				requestPrice: "0",
				contextSize: 1048576,
				maxOutput: 8192,
				streaming: true,
				vision: true,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "llama-3-8b-instruct",
		name: "Llama 3 8B Instruct",
		description: "Llama 3 8B instruction-following model.",
		family: "meta",
		releasedAt: new Date("2025-04-03"),
		providers: [
			{
				providerId: "novita",
				externalId: "meta-llama/llama-3-8b-instruct",
				inputPrice: "0.04e-6",
				outputPrice: "0.04e-6",
				requestPrice: "0",
				contextSize: 8192,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "llama-3-70b-instruct",
		name: "Llama 3 70B Instruct",
		description: "Llama 3 70B instruction-following model.",
		family: "meta",
		releasedAt: new Date("2024-04-18"),
		providers: [
			{
				providerId: "novita",
				test: "skip", // skip tests, provider returns 500
				externalId: "meta-llama/llama-3-70b-instruct",
				inputPrice: "0.51e-6",
				outputPrice: "0.74e-6",
				requestPrice: "0",
				contextSize: 8192,
				maxOutput: 8000,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
	{
		id: "llama-3.2-3b-instruct",
		name: "Llama 3.2 3B Instruct",
		description: "Compact Llama 3.2 3B for efficient inference.",
		family: "meta",
		releasedAt: new Date("2024-09-18"),
		providers: [
			{
				providerId: "novita",
				stability: "unstable",
				externalId: "meta-llama/llama-3.2-3b-instruct",
				inputPrice: "0.03e-6",
				outputPrice: "0.05e-6",
				requestPrice: "0",
				contextSize: 32768,
				maxOutput: 32000,
				streaming: true,
				vision: false,
				tools: false,
				jsonOutput: true,
			},
		],
	},
] as const satisfies ModelDefinition[];
